import React, { useContext } from 'react';
import ChooseAmount from './ChooseAmount';
import { DonationContext } from './Context';
import Information from './Information';
import Payment from './Payment';
import Success from './Success';

function Step() {
  const { activeStepIndex } = useContext(DonationContext);
  let stepContent;
  switch (activeStepIndex) {
    case 0:
      stepContent = <ChooseAmount />;
      break;
    case 1:
      stepContent = <Information />;
      break;
    case 2:
      stepContent = <Payment />;
      break;
    case 3:
      stepContent = <Success />;
      break;
    default:
      break;
  }
  return stepContent;
}

export default Step;
